namespace TabAurous.Administration {
    export interface QualityInspectionTemplateDetailsRow {
        DetailId?: number;
        TemplateId?: number;
        Parameter?: string;
        Value?: string;
        IsNumeric?: boolean;
        Min?: number;
        Max?: number;
    }

    export namespace QualityInspectionTemplateDetailsRow {
        export const idProperty = 'DetailId';
        export const nameProperty = 'Parameter';
        export const localTextPrefix = 'Administration.QualityInspectionTemplateDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailId = "DetailId",
            TemplateId = "TemplateId",
            Parameter = "Parameter",
            Value = "Value",
            IsNumeric = "IsNumeric",
            Min = "Min",
            Max = "Max"
        }
    }
}
